import { render } from "./platform.vue?vue&type=template&id=769e07b4&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./platform.vue?vue&type=style&index=0&id=769e07b4&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\cnb_2\\oulimojuxiaozhunxitong\\BOSS_GC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769e07b4"]])

export default __exports__